<template>
  <el-container :key="reRender" class="wrapper" :class="`lang-${lang}`">
    <el-aside v-show="showMenu" :width="!matches ? center : ''">
      <slideBar :matches="matches" :onOpen.sync="onOpen" @matchesClose="matchesClose"></slideBar>
    </el-aside>
    <el-container class="is-vertical">
      <vHeader :matches="matches" @openMenu="openMenu" @readGuide="readGuide"></vHeader>
      <el-main id="elMain">
        <div class="main_layout" :class="{ full_layout: fullWidth }">
          <!-- count down timer on TC page -->
          <CountdownTimer
            v-if="$route.meta.campaignStartTimestamp"
            :campaignName="$route.meta.campaignName"
            :targetTime="$route.meta.campaignStartTimestamp"
            day
            hour
            minute
          />
          <Banner v-if="showBanner"></Banner>
          <transition>
            <router-view></router-view>
          </transition>
          <SessionDialog />
          <vFooter></vFooter>
        </div>
      </el-main>
    </el-container>
    <PopupBanner v-if="showPopupBanner" @readGuide="readGuide" />
  </el-container>
</template>

<script>
import { apiSetlanguage, apiHomeDoneGuide, apiHomeReadGuide } from '@/resource';
import { popupBannerDisplayPageWhiteList } from '@/constants/popupBanner';
import vHeader from '@/components/Header';
import slideBar from '@/components/Menu';
import Banner from '@/components/banner/Banner';
import SessionDialog from '@/components/SessionDialog.vue';
import vFooter from '@/components/Footer';
import PopupBanner from '@/components/popupBanner/PopupBanner';
import { guide } from '@/util/driver';
import { loadDownloadI18n } from '@/resource/i18n';
import CountdownTimer from '@/components/promotion/CountdownTimer.vue';

export default {
  name: 'layout',
  data() {
    return {
      reRender: 0,
      center: '230px',
      matches: false,
      showMenu: false,
      onOpen: true,
      showBanner: false,
      showPopupBanner: false,
      fullWidth: false
    };
  },
  components: { vHeader, slideBar, Banner, SessionDialog, vFooter, PopupBanner, CountdownTimer },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    },
    notificationVisible() {
      return this.$store.state.common.notificationVisible;
    }
  },
  watch: {
    lang: {
      immediate: true,
      async handler(val) {
        loadDownloadI18n(val).then(async res => {
          await this.initLang();
          this.reRender++;
          this.$store.dispatch('payment/actionSetPCSI18n');
        });
      }
    },
    reRender(reRender) {
      if (this.$route.meta.restrictReload) this.$router.push('/home');
    },
    matches(bool) {
      if (bool) {
        this.onOpen = false;
        this.center = '0';
      } else {
        this.onOpen = true;
        this.center = '230px';
      }
    },
    $route: {
      handler: function (route) {
        this.showMenu = route.meta.allowAnonymous ? false : true;
        this.showBanner = route.meta.restrictBanner ? false : true;
        this.fullWidth = route.meta.fullWidth ? true : false;
        this.setShowPopupBanner(route.path);

        if (route.path === '/home' && !this.showPopupBanner) {
          setTimeout(() => {
            this.readGuide();
          }, 2500);
        }

        this.$nextTick(() => {
          const elMain = document.getElementById('elMain');
          elMain.scrollTop = route.path.indexOf('deposit/') != -1 ? 370 : 0;
        });
      },
      immediate: true
    }
  },
  mounted() {
    const vm = this;
    this.matches = window.matchMedia('(max-width: 1024px)').matches;
    $(window).resize(function () {
      vm.matches = window.matchMedia('(max-width: 1024px)').matches;
    });

    this.setShowPopupBanner(this.$route.path);
    this.initLang();
  },
  methods: {
    async setUserLanguagePreference(lang) {
      await apiSetlanguage({ language: lang });
      this.$store.dispatch('regulator/actionGetInformation');
    },
    matchesClose() {
      this.onOpen = !this.onOpen;
    },
    openMenu() {
      this.onOpen = !this.onOpen;
    },
    setShowPopupBanner(routePath) {
      if (popupBannerDisplayPageWhiteList.includes(routePath)) {
        this.showPopupBanner = true;
      } else {
        this.showPopupBanner = false;
      }
    },
    readGuide(val) {
      if (this.$route.path == '/home') {
        if (val === 'fromBanner' && this.notificationVisible === true) {
          return apiHomeReadGuide().then(resp => {
            const response = resp.data;

            if (response.data === false) {
              setTimeout(() => {
                guide();
                this.doneRead();
              }, 1000);
            }
          }, this.$handleError);
        } else if (val === 'fromPopUp' && this.notificationVisible === false) {
          return apiHomeReadGuide().then(resp => {
            const response = resp.data;

            if (response.data === false) {
              setTimeout(() => {
                guide();
                this.doneRead();
              }, 1000);
            }
          }, this.$handleError);
        }
      }
    },
    doneRead() {
      return apiHomeDoneGuide().then(resp => {
        const response = resp.data;
        console.log(response.data);
      }, this.$handleError);
    },
    async initLang() {
      this.$i18n.locale = this.lang;
      if (this.$store.state.common.loginStatus) await this.setUserLanguagePreference(this.lang);
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/css/app.scss';
.full_layout {
  width: 100%;
  padding: 0;
  max-width: 100%;
}
.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 0.5s;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 0.2s;
}
.v-enter-to {
  opacity: 1;
}
@import '../../assets/Oblivian-Regular/stylesheet.css';
@import '../../assets/NotoSansCJKJapanese-hinted/stylesheet.css';
@import '../../assets/NotoSansCJKKorean-hinted/stylesheet.css';
@import '../../assets/NotoSansCJKSimChinese-hinted/stylesheet.css';
@import '../../assets/NotoSans-hinted/stylesheet.css';
@import '../../assets/NotoSans-Bold/stylesheet.css';
@import '../../assets/PingFangSC/stylesheet.css';
@import '../../assets/NotoSans/stylesheet.css';
@import '../../assets/Oswald/stylesheet.css';
@import '../../assets/NotoSansThaiLooped/stylesheet.css';
@import '../../assets/font/Lato/stylesheet.css';
@import '../../assets/font/Inter/stylesheet.css';
@import '../../assets/font/PublicSans/stylesheet.css';
@import '@/assets/css/driver.scss';
</style>
